import { useContext, useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate, useResolvedPath } from "react-router-dom";
import { MenuProps } from "antd/lib/menu";

import { CloseOutlined, DownOutlined, MenuOutlined, MoonOutlined, SunOutlined } from "@ant-design/icons";
import { Button, Flex, Grid, Menu, Layout, Avatar, Dropdown, Space, Typography, Modal, Tooltip } from "antd";
import { AlterarSenhaAR } from "../Views/Acesso/Acesso.alterarSenha";
import { CancelarSessaoERemoverToken } from "../Views/Sistema/Splash";
import { EnumTipoUsuario } from "../../Models/Domain/AreaRestrita/Sessao";
import { ParametrosDaSessaoARContext } from "../Views/Sistema/ParametrosDaSessao";
import { SessaoARContext } from "../Contexts/SessaoContext";

import Utilitario from "../../Utils/Utilitario";

const logoQuiron = require('../../Assets/logo-quiron.png');
const cores = {
    amareloEscuro: '#eda051'
}

export const MenuApp = ({ collapsed, setCollapsed }: { collapsed: boolean, setCollapsed: Function }) => {
    const SessaoAR = useContext(SessaoARContext);

    const breakpoints = Grid.useBreakpoint();
    const location = useLocation();

    const chaveDoMenu = useMemo(() => {
        const tipoDeUsuario = SessaoAR?.sessao?.tipoDeUsuario;

        if (location.pathname == "/") return undefined;

        if (tipoDeUsuario == undefined) return undefined;

        if (tipoDeUsuario == EnumTipoUsuario.Aluno) {
        }
        else if (tipoDeUsuario == EnumTipoUsuario.Responsavel) {
            if (location.pathname.match(/^\/viagens(\/|$)/)) return "viagens"
            if (location.pathname.match(/^\/meus-dados(\/|$)/)) return "meus-dados"
        } else if (tipoDeUsuario == EnumTipoUsuario.Escola) {
            if (location.pathname.match(/^\/viagens(\/|$)/)) return "viagens"
            if (location.pathname.match(/^\/meus-dados(\/|$)/)) return "meus-dados"
        }

    }, [location])

    useEffect(() => {
        if (breakpoints.lg == false) {
            setCollapsed(true)
        }
    }, [location]);

    const itensDoMenu: MenuProps['items'] = useMemo(() => {
        const tipoDeUsuario = SessaoAR?.sessao?.tipoDeUsuario;
        if (SessaoAR?.sessao?.usuario == undefined || tipoDeUsuario == undefined) return undefined;

        switch (tipoDeUsuario) {
            case EnumTipoUsuario.Aluno:
                return []
            case EnumTipoUsuario.Responsavel:
                return [
                    { key: "viagens", label: <Link to="/viagens"> Minhas Viagens </Link> },
                    { key: "meus-dados", label: <Link to="/meus-dados/responsavel"> Dados Cadastrais </Link> }
                ]
            case EnumTipoUsuario.Escola:
                return [
                    { key: "viagens", label: <Link to="/viagens"> Minhas Viagens </Link> },
                    { key: "meus-dados", label: <Link to="/meus-dados/escola"> Dados Cadastrais </Link> }
                ]
        }

    }, [SessaoAR?.sessao]);

    return (<>
        <Flex gap={8} vertical={!breakpoints.lg}>
            {breakpoints.lg &&
                <Link to="/">
                    <div style={{ padding: '8px', textAlign: 'center', cursor: "pointer" }} >
                        <img src={logoQuiron} width={'80px'} />
                    </div>
                </Link>
            }
            <Menu
                mode={breakpoints.lg == undefined || breakpoints.lg ? "horizontal" : "vertical"}
                theme='dark'
                items={itensDoMenu}
                selectedKeys={chaveDoMenu ? [chaveDoMenu] : []}
            />
        </Flex>
    </>)
}

export const LayoutHeader = ({ collapsed, setCollapsed, temaEscuro, setTemaEscuro }: { collapsed: boolean, setCollapsed: Function, temaEscuro: boolean, setTemaEscuro: Function }) => {
    const navigate = useNavigate();
    const breakpoints = Grid.useBreakpoint();

    const SessaoAR = useContext(SessaoARContext);
    const ParametrosAR = useContext(ParametrosDaSessaoARContext);

    const usuario = SessaoAR?.sessao?.info;
    const tipoDeUsuario = ParametrosAR?.tipoDeUsuario;


    const [statusDoModalDeAlterarSenha, setStatusDoModalDeAlterarSenha] = useState<{ exibir: boolean }>({ exibir: false });

    const { capitalizarIniciais } = Utilitario;

    function trocarRota(rota: string) {
        navigate(rota);
        setCollapsed(false);
    }

    const itemsDaDropdown: MenuProps['items'] = [
        {
            label: 'Alterar senha',
            key: '1',
            onClick: () => {
                setStatusDoModalDeAlterarSenha({ exibir: true })
            }
        },
        // Remover opção de cadastrar novo aluno
        // ParametrosAR?.tipoDeUsuario === EnumTipoUsuario.Responsavel && ParametrosAR.bloquearTrocaDeAlunos !== true ?
        //     {
        //         label: 'Selecionar aluno',
        //         key: '2',
        //         onClick: () => {
        //             if (ParametrosAR?.tipoDeUsuario == EnumTipoUsuario.Responsavel) {
        //                 ParametrosAR.setExibirSelecaoDeAluno(true);
        //             }
        //         }
        //     } : undefined,
        // ParametrosAR?.tipoDeUsuario === EnumTipoUsuario.Responsavel?
        //     {
        //         label: 'Novo aluno',
        //         key: '4',
        //         onClick: () => {
        //             if (ParametrosAR?.tipoDeUsuario == EnumTipoUsuario.Responsavel) {
        //                 ParametrosAR.setExibirNovoAluno(true);
        //             }
        //         }
        //     } : undefined,
        {
            label: 'Sair',
            key: '5',
            onClick: () => {
                Modal.confirm({
                    title: "Sair da sessão?",
                    okText: "Sair",
                    onOk: () => {
                        CancelarSessaoERemoverToken(SessaoAR?.setSessao);
                        navigate("/")
                    },

                })
            }
        }
    ].filter((v) => v !== undefined);

    return (<div>
        <Modal
            destroyOnClose
            open={statusDoModalDeAlterarSenha.exibir == true}
            footer={null}
            maskClosable={false}
            onCancel={() => {
                setStatusDoModalDeAlterarSenha({ exibir: false })
            }}
        >
            <AlterarSenhaAR depoisDeFinalizar={() => {
                setStatusDoModalDeAlterarSenha({ exibir: false })
            }} />
        </Modal>

        <Layout.Header style={breakpoints.lg ? { display: "flex", justifyContent: "space-between" } : { display: "flex", justifyContent: "space-between", padding: '0px 16px', position: "sticky", top: 0, zIndex: 4 }}>
            {
                breakpoints.lg &&
                <MenuApp collapsed={collapsed} setCollapsed={setCollapsed} />
            }
            {
                !breakpoints.lg &&
                <Flex gap={16} align='center' style={{ height: '100%' }}>
                    <Button
                        type="text"
                        icon={collapsed ? <MenuOutlined /> : <CloseOutlined />}
                        onClick={() => setCollapsed(!collapsed)}
                        style={{
                            fontSize: '16px',
                            width: 32,
                            height: 32,
                            color: 'white'
                        }}
                    />
                    <Link to="/" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <img src={logoQuiron} width={'80px'} />
                    </Link>
                </Flex>
            }

            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                <Space size={'middle'}>
                <Tooltip title={temaEscuro ? "Modo Claro" : "Modo Escuro"} >
                    <Button type="primary" shape="circle" icon={temaEscuro ? <SunOutlined /> : <MoonOutlined />} onClick={() => setTemaEscuro(!temaEscuro)} />
                </Tooltip>
                {SessaoAR?.sessao?.token != undefined && SessaoAR?.sessao?.usuario != undefined &&
                    <Dropdown menu={{ items: itemsDaDropdown }}>
                        <Flex align='center' gap={breakpoints.lg ? 16 : 8}>
                            {
                                breakpoints.lg &&
                                <Avatar shape='square' style={{ backgroundColor: cores.amareloEscuro, fontWeight: 600, cursor: 'default' }} size={40}>
                                    {usuario?.pessoa?.nome?.at(0)?.toLocaleUpperCase()}
                                </Avatar>
                            }

                            <Space style={{ color: 'white', fontWeight: 600 }}>
                                <Typography style={{ color: 'inherit' }}>
                                    <Typography.Text style={{ color: "inherit" }}>
                                        {
                                            capitalizarIniciais(
                                                breakpoints.sm ? usuario?.pessoa?.nome : usuario?.pessoa?.nome?.split(" ").at(0)
                                            )
                                        }
                                    </Typography.Text>
                                    <br />
                                    {
                                        tipoDeUsuario == EnumTipoUsuario.Responsavel ?
                                            null
                                            :
                                            <Typography.Text style={{ color: cores.amareloEscuro, fontWeight: 400 }}>
                                                {
                                                    (() => {
                                                        switch (SessaoAR.sessao.tipoDeUsuario) {
                                                            case EnumTipoUsuario.Aluno:
                                                                return "Aluno"
                                                            case EnumTipoUsuario.Responsavel:
                                                                return "Responsável"
                                                            case EnumTipoUsuario.Escola:
                                                                return "Escola"
                                                            default:
                                                                return "Nenhum"
                                                        }
                                                    })()
                                                }
                                            </Typography.Text>
                                    }
                                </Typography>

                                <Button type="text"
                                    style={{
                                        height: "40px",
                                        paddingLeft: "2px",
                                        paddingRight: "2px",
                                        display: 'flex',
                                        flexDirection: 'column-reverse',
                                    }}
                                >
                                    <Typography.Text style={{ color: "white" }}>
                                        <DownOutlined />
                                    </Typography.Text>
                                </Button>
                            </Space>

                        </Flex>
                    </Dropdown>
                }
                </Space>
            </div>
        </Layout.Header>
    </div>
    );
};
